/*
  Mobile Menu
*/

class MobileMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const hamb = this.querySelector("#hamburger-icon");

    hamb.addEventListener("click", (e) => {
      const menu = this.querySelector(".mobile-menu");
      if (hamb.classList.contains("active")) {
        hamb.classList.remove("active");
        menu.classList.remove("active");
      } else {
        hamb.classList.add("active");
        menu.classList.add("active");
        header.classList.add("active");
      }
    });
  }
}

customElements.define("mobile-menu", MobileMenu);

/*
Cart Toggle
*/

class CartToggle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.querySelector("button")) {
      console.warn("Cart toggle component should have a button as a child!");
    }

    this.addEventListener("click", (e) => {
      const cart = document.querySelector("site-cart");
      if (cart) {
        cart.toggleCart();
      }
    });
  }
}

customElements.define("cart-toggle", CartToggle);

/*
Cart Item
*/

class CartItem extends HTMLElement {
  connectedCallback() {
    this.optionSelectorsSelectEls = Array.from(
      this.querySelectorAll(".option-selectors select")
    );
    this.quantityInputEl = this.querySelector("number-input input");
    this.removeButtonEl = this.querySelector(".remove-button-js");
    this.upgradeButtonEl = this.querySelector(".upgrade-to-sub-js");
    this.product = JSON.parse(this.dataset.product);
    this.selectedVariant = JSON.parse(this.dataset.selectedVariant);
    this.optionsWithValues = JSON.parse(this.dataset.productOptionsWithValues);
    this.cartIndex = this.dataset.cartIndex;

    this.hideUnavailableOptions();
    this.addOptionChangeEvents();
    this.addQuantityChangeEvent();
    this.addRemoveEvent();
    this.addUpgradeEvent();
  }

  hideUnavailableOptions() {
    this.optionSelectorsSelectEls.forEach((select) => {
      const options = Array.from(select.querySelectorAll("option"));
      options.forEach((option) => {
        const predictedOption = CartItem.predictVariantOption(
          this.product.variants,
          this.optionsWithValues,
          this.selectedVariant,
          option.dataset.optionName,
          option.value
        );

        if (!predictedOption.available) {
          option.setAttribute("disabled", "");
        }
      });
    });
  }

  addOptionChangeEvents() {
    this.optionSelectorsSelectEls.forEach((select) => {
      select.addEventListener("change", () => {
        const siteCart = document.querySelector("site-cart");
        const selectedOptions = this.optionSelectorsSelectEls.map(
          (select) => select.value
        );
        const newVariant = CartItem.findVariantByOptions(
          this.product.variants,
          selectedOptions
        );
        const quantityVal = +this.quantityInputEl.value;
        siteCart.updateCart({
          [this.selectedVariant.id]: 0,
          [newVariant.id]: quantityVal,
        });
      });
    });
  }

  addQuantityChangeEvent() {
    this.quantityInputEl.addEventListener("change", () => {
      const siteCart = document.querySelector("site-cart");
      const quantityVal = +this.quantityInputEl.value;
      const item = this.quantityInputEl.closest("cart-item");

      item
        .querySelector(".cart-item__totals")
        .firstElementChild.classList.add("hidden");
      item
        .querySelector(".cart-item__totals")
        .lastElementChild.classList.remove("hidden");
      siteCart.updateCart({ [this.selectedVariant.id]: quantityVal });
    });
  }

  addRemoveEvent() {
    this.removeButtonEl.addEventListener("click", (e) => {
      const item = e.target.closest("cart-item");

      item
        .querySelector(".cart-item__totals")
        .firstElementChild.classList.add("hidden");
      item
        .querySelector(".cart-item__totals")
        .lastElementChild.classList.remove("hidden");

      const siteCart = document.querySelector("site-cart");
      siteCart.updateCart({ [this.selectedVariant.id]: 0 });
    });
  }

  addUpgradeEvent() {
    if (this.upgradeButtonEl) {
      this.upgradeButtonEl.addEventListener("click", async (e) => {
        const siteCart = document.querySelector("site-cart");
        const item = e.target.closest("cart-item");
        const line = item.dataset.cartIndex;
        const sellingPlanId = e.target.dataset.sellingPlanId;
        const variantId = e.target.dataset.variantId;

        item
          .querySelector(".cart-item__totals")
          .firstElementChild.classList.add("hidden");
        item
          .querySelector(".cart-item__totals")
          .lastElementChild.classList.remove("hidden");

        await siteCart.upgradeToSubscription(line, 1, variantId, sellingPlanId);
      });
    }
  }

  static predictVariantOption(
    variants,
    optionsWithValues,
    selectedVariant,
    optionName,
    value
  ) {
    const predictedOptions = optionsWithValues.map((option) => {
      if (option.name === optionName) {
        return value;
      }

      return selectedVariant.options.find((opt) => option.values.includes(opt));
    });

    const predictedVariant = CartItem.findVariantByOptions(
      variants,
      predictedOptions
    );

    return {
      available: predictedVariant.available,
      priceDiff: predictedVariant.price - selectedVariant.price,
      variant: predictedVariant,
    };
  }

  static findVariantByOptions(variants, options) {
    const variant = variants.find((variant) => {
      const currentOptsStr = JSON.stringify(options.sort());
      const variantOptsStr = JSON.stringify(variant.options.sort());
      return currentOptsStr === variantOptsStr;
    });

    return variant;
  }

  upgradeToSubsctiption() {}
}

customElements.define("cart-item", CartItem);

/*
  Site Cart
*/

class SiteCart extends HTMLElement {
  constructor() {
    super();
    this.cart = null;
  }

  connectedCallback() {
    this.cart = document.querySelector(".site-cart");
    this.addSelectEvents();
  }

  addSelectEvents() {
    this.querySelectorAll("select").forEach((select) => {
      select.addEventListener("change", (e) => {
        const option = select.querySelector(
          `option[value="${e.target.value}"]`
        );

        if (option) {
          const subId = option.dataset.id;
          const variantId = option.dataset.variantId;
          const item = select.closest("cart-item");
          const line = item.dataset.cartIndex;

          item
            .querySelector(".cart-item__totals")
            .firstElementChild.classList.add("hidden");
          item
            .querySelector(".cart-item__totals")
            .lastElementChild.classList.remove("hidden");

          this.upgradeToSubscription(line, 1, variantId, subId);
        }
      });
    });
  }

  getCartData() {
    return fetch("/cart.js")
      .then((response) => response.json())
      .then((response) => {
        return response;
      });
  }

  openCart() {
    if (this.cart) {
      this.cart.classList.add("active");
      document.body.style.overflow = "hidden";
    }
  }

  closeCart() {
    if (this.cart) {
      this.cart.classList.remove("active");
      document.body.removeAttribute("style");
    }
  }

  toggleCart() {
    if (this.cart.classList.contains("active")) {
      this.closeCart();
    } else {
      this.openCart();
    }
  }

  getCartSections() {
    return [
      {
        section: "main-cart-items",
        selector: "#main-cart-items",
      },
      {
        section: "main-cart-footer",
        selector: "#main-cart-footer",
      },
      {
        section: "main-cart-header",
        selector: "#main-cart-header",
      },
      {
        section: "header",
        selector: "#shopify-section-header",
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  renderCartSections(sections) {
    const getSections = this.getCartSections();
    const sectionsArr = Object.keys(sections);

    sectionsArr.forEach((sectionKey) => {
      const activeSection = getSections.find((s) => s.section === sectionKey);
      const elToReplace = document.querySelector(activeSection.selector);
      if (elToReplace) {
        const html = this.getSectionInnerHTML(
          sections[sectionKey],
          activeSection.selector
        );
        elToReplace.innerHTML = html;
      }
    });

       const miniCartBottom = document.querySelector('#shopify-section-main-cart-footer');
    const cartItemsContent = document.querySelector('.cart__container');
    console.log(miniCartBottom);
    if (miniCartBottom && cartItemsContent) {
        const height = miniCartBottom.offsetHeight + 10;
        cartItemsContent.style.paddingBottom = `${height}px`;
    }
  }

  buildConfig(body) {
    return {
      body: body,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
    };
  }

  addVariantToCart(id, quantity = 1, sellingPlan) {
    const items = [
      sellingPlan
        ? { id, quantity, selling_plan: sellingPlan }
        : { id, quantity },
    ];
    const sections = this.getCartSections().map((s) => s.section);
    const body = JSON.stringify({ items, sections });
    const config = this.buildConfig(body);

    if (!this.cart.classList.contains("active")) {
      this.toggleCart();
    }

    return fetch(`/cart/add`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }
        const cartCount = document.querySelector("#cart_item_count_header");
         if (cartCount) {
     // cartCount.textContent =response.item_count ;
    }
        this.renderCartSections(response.sections);
      })
      .catch((e) => {
        // handle error
      });
  }

  updateQuantity(line, quantity) {
    const sections = this.getCartSections().map((s) => s.section);
    const body = JSON.stringify({ line, quantity, sections });
    const config = this.buildConfig(body);

    return fetch("/cart/change", config)
      .then((response) => response.json())
      .then((response) => {
           const cartCount = document.querySelector("#cart_item_count_header");
         if (cartCount) {
      cartCount.textContent =response.item_count ;
    }
        this.renderCartSections(response.sections);
      })
      .catch(() => {
        // handle error
      });
  }

  updateCart(updates, shouldRefresh = true) {
    const sections = this.getCartSections().map((s) => s.section);
    const body = JSON.stringify({ updates, sections });
    const config = this.buildConfig(body);

    return fetch("/cart/update", config)
      .then((response) => response.json())
      .then((response) => {
        if (shouldRefresh) {
             const cartCount = document.querySelector("#cart_item_count_header");
         if (cartCount) {
      cartCount.textContent =response.item_count ;
    }
          this.renderCartSections(response.sections);
        }
      })
      .catch(() => {
        // handle error
      });
  }

  addSellingPlan(variantId, sellingPlan) {
    const sections = this.getCartSections().map((s) => s.section);
    const data = {
      id: variantId,
      selling_plan: sellingPlan,
      sections,
    };
    const body = JSON.stringify(data);
    const config = this.buildConfig(body);

    return fetch("/cart/change", config)
      .then((response) => response.json())
      .then((response) => {
           const cartCount = document.querySelector("#cart_item_count_header");
         if (cartCount) {
      cartCount.textContent =response.item_count ;
    }
        this.renderCartSections(response.sections);
        this.addSelectEvents();
      })
      .catch(() => {
        // handle error
      });
  }

  async upgradeToSubscription(line, quantity, variantId, sellingPlan) {
    const cartData = await this.getCartData();
    const index0 = +line - 1;
    const variantToRemove = cartData.items[index0].variant_id;

    await this.updateCart(
      {
        [variantToRemove]: 0,
        [variantId]: { quantity, selling_plan: sellingPlan },
      },
      false
    );

    this.addSellingPlan(variantId, sellingPlan);
  }
}

customElements.define("site-cart", SiteCart);

/*
Number Input
*/

class NumberInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const button = event.target.closest("button");

    if (button) {
      button.name === "increment" ? this.input.stepUp() : this.input.stepDown();

      if (previousValue !== this.input.value) {
        this.input.dispatchEvent(this.changeEvent);
      }
    }
  }
}

customElements.define("number-input", NumberInput);

/*
Cart Add
*/

class CartAdd extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", async (e) => {
      const form = e.target.closest("form");
      e.preventDefault();

      const $id = form.querySelector('[name="id"]');
      const $qty = form.querySelector('[name="quantity"]');
      const $sellingPlan = form.querySelector('[name="selling_plan"]');
      const qty = $qty ? $qty.value : 1;
      const sellingPlan =
        $sellingPlan && !!$sellingPlan.value ? $sellingPlan.value : null;

      if ($id) {
        const cart = document.querySelector("site-cart");
        if (cart) {
          await cart.addVariantToCart($id.value, qty, sellingPlan);
        }
      }
    });
  }
}

customElements.define("cart-add", CartAdd);

/*
Cart Remove
*/

class CartRemove extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", async (e) => {
      e.preventDefault();

      const cart = document.querySelector("site-cart");
      const idx = this.dataset.index;

      if (cart) {
        await cart.updateQuantity(idx, 0);
      }
    });
  }
}

customElements.define("cart-remove", CartRemove);

/*
 * site-video
 **/

class SiteVideo extends HTMLElement {
  constructor() {
    super();
    this.observe();
  }

  observe() {
    if ("IntersectionObserver" in window) {
      const videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(function (video) {
          const $video = video.target;
          if (video.isIntersecting) {
            if ($video.readyState === 4) {
              $video.play();
            } else {
              [].slice
                .call($video.querySelectorAll("source"))
                .forEach((source) => {
                  source.src = source.dataset.src;
                });
              $video.load();
            }
          } else {
            if (!$video.paused) {
              $video.pause();
            }
          }
        });
      });

      videoObserver.observe(this.querySelector("video"));
    }
  }
}

customElements.define("site-video", SiteVideo);

/*
 * Swiper Carousel
 */

class SwiperCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.id = this.dataset.id;
    this.initCarousel(this.data);
    this.setupListeners();
  }

  setupListeners() {
    const pagers = this.querySelectorAll(".carousel-pager");
    const prev = this.querySelector(".carousel-prev");
    const next = this.querySelector(".carousel-next");

    if (prev) {
      prev.addEventListener("click", () => {
        if (this.swiper) {
          this.swiper.slidePrev();
        }
      });
    }

    if (next) {
      next.addEventListener("click", () => {
        if (this.swiper) {
          this.swiper.slideNext();
        }
      });
    }

    Array.from(pagers).forEach((pager, i) => {
      pager.addEventListener("click", (e) => {
        this.swiper.slideTo(i);
      });
    });

    this.swiper.on("slideChange", () => {
      pagers.forEach((el) => el.classList.remove("active"));
      const nextPager = pagers[this.swiper.realIndex];
      if (nextPager) {
        nextPager.classList.add("active");
      }

      if (prev) {
        if (this.swiper.realIndex > 0) {
          prev.removeAttribute("disabled");
        } else {
          prev.setAttribute("disabled", "");
        }
      }

      if (next) {
        if (this.swiper.realIndex === pagers.length - 1) {
          next.setAttribute("disabled", "");
        } else {
          next.removeAttribute("disabled");
        }
      }
    });
  }

  initCarousel(config = { slidesPerView: 3, spaceBetween: 20 }) {
    this.swiper = new Swiper(`#${this.id} .swiper`, config);
  }
}

customElements.define("swiper-carousel", SwiperCarousel);

/*
  Featured Product Atc
*/

class FeaturedProductAtc extends HTMLElement {
  constructor() {
    super();
    this.sellingPlanId;
    this.sellingPlanPrice;
    this.variantId;
    this.variantPrice;
    this.productQuantity;
    this.productTitle;
  }

  connectedCallback() {
    const primaryLabel = this.querySelector(
      ".featured-product__additional-package"
    );

    this.productHandle(primaryLabel);
    this.setupListeners();

    this.querySelector(".button--atc").disabled = false;
  }

  setupListeners() {
    this.querySelectorAll(".featured-product__additional-package").forEach(
      (label) => {
        label.addEventListener("click", () => {
          this.productHandle(label);
        });
      }
    );

    this.querySelector("form").addEventListener("submit", (event) => {
      event.preventDefault();

      const cart = document.querySelector("site-cart");
      const selectedPackage = this.querySelector(
        'input[name="selling-plan"]:checked'
      );

      if (selectedPackage.id == "subscribe-plan") {
        cart.addVariantToCart(this.variantId, 1, this.sellingPlanId);
      } else {
        cart.addVariantToCart(this.variantId, 1);
      }
    });
  }

  productHandle(label) {
    if (label) {
      this.querySelector("#one-time").checked = true;

      this.sellingPlanId = label.dataset.sellingPlanId;
      this.sellingPlanPrice = label.dataset.sellingPlanPrice;
      this.variantId = label.dataset.variantId;
      this.variantPrice = label.dataset.variantPrice;
      this.productQuantity = label.dataset.productQuantity;

      const priceEl = this.querySelector(".featured-product__price");
      const linePriceEl = this.querySelector(".featured-product__line-price");

      const subscribeEl = this.querySelector(".subscribe-radio");
      const subscribeInputEl = subscribeEl.querySelector("input");
      const subscriptionPriceEl = subscribeEl.querySelector(
        ".featured-product__subscription-price"
      );

      this.querySelector(
        ".featured-product__package-qty"
      ).innerHTML = `${this.productQuantity} Bottles`;

      priceEl.innerHTML = this.variantPrice;
      linePriceEl.innerHTML = this.variantPrice;
      subscriptionPriceEl.innerHTML = this.sellingPlanPrice;

      if (!this.sellingPlanId || !this.sellingPlanPrice) {
        subscribeEl.style.opacity = "50%";
        subscribeInputEl.disabled = true;
      } else {
        subscribeEl.style.opacity = "100%";
        subscribeInputEl.disabled = false;
      }
    }
  }
}

customElements.define("featured-product-atc", FeaturedProductAtc);

/*
  Quantity Modifier
*/

class QuantityModifier extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updateContent(3);
    document.addEventListener("updateQuantity", (event) => {
      const { quantity } = event.detail;
      this.updateContent(quantity);
    });
  }
  updateContent(quantity) {
    this.querySelector("span").textContent = `${quantity} Bottle${
      quantity > 1 ? "s" : ""
    }`;
  }
}

customElements.define("quantity-modifier", QuantityModifier);

/*
  Quantity Modifier
*/

class SubscriptionPriceModifier extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener("updateSubscriptionPrice", (event) => {
      const { subPrice } = event.detail;
      this.updateContent(subPrice);
    });
  }
  updateContent(subPrice) {
    this.querySelector("span").textContent = `${subPrice}`;
  }
}

customElements.define("subscirption-price-modifier", SubscriptionPriceModifier);

/*
  Price Modifier
*/

class PriceModifier extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener("updatePrice", (event) => {
      const { price } = event.detail;
      this.updateContent(price);
    });
  }
  updateContent(price) {
    this.querySelector("span").textContent = `${price}`;
  }
}

customElements.define("price-modifier", PriceModifier);

/*
  Marquee
*/

class MarqueeCarousel extends HTMLElement {
  constructor() {
    super();
    this.setMarquee();
  }

  setMarquee() {
    const speed = 0.2;
    const parentSelector = this.querySelector("marquee-carousel > div");
    const clone = parentSelector.innerHTML;
    const firstElement = parentSelector.children[0];
    let i = 0;
    parentSelector.insertAdjacentHTML("beforeend", clone);
    parentSelector.insertAdjacentHTML("beforeend", clone);

    setInterval(function () {
      firstElement.style.marginLeft = `-${i}px`;
      if (i > firstElement.clientWidth) {
        i = 0;
      }
      i = i + speed;
    }, 0);
  }
}

customElements.define("marquee-carousel", MarqueeCarousel);

/* PDP Info Tabs */

class PDPInfoTabs extends HTMLElement {
  constructor() {
    super();
    this.setPDPInfoTabs();
  }

  setPDPInfoTabs() {
    Array.from(this.querySelectorAll(".product_info_button")).forEach(
      (buttonTab) => {
        buttonTab.addEventListener("click", (e) => {
          const button = e.target.closest("button");
          const idx = button.dataset.infoButton;
          Array.from(this.querySelectorAll("[data-info-button]")).forEach(
            (button) => {
              button.classList.remove("product_btn_active");
            }
          );
          button.classList.add("product_btn_active");
          Array.from(this.querySelectorAll("[data-info-description]")).forEach(
            (desc) => {
              desc.classList.remove("product_info_active");
            }
          );
          this.querySelector(`[data-info-description="${idx}"]`).classList.add(
            "product_info_active"
          );
          this.querySelector(`[data-info-button="${idx}"]`).classList.add(
            "product_btn_active"
          );
        });
      }
    );
  }
}

customElements.define("pdp-info-tabs", PDPInfoTabs);

/*
  Video Player
*/

class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.videoPlayer();
  }

  videoPlayer() {
    let videoControls = this.querySelector("video");
    let playButton = this.querySelector("button");

    playButton.addEventListener("click", function () {
      if (videoControls.paused) {
        videoControls.play();
        playButton.querySelector("button span").style.display = "none";
      } else {
        videoControls.pause();
        playButton.querySelector("button span").style.display = "block";
      }
    });
  }
}

customElements.define("video-player", VideoPlayer);

/*
  Toggle All Accordion
*/

class ToggleAllAccordions extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const labels = this.querySelectorAll("label p");
    if (!this.querySelector("input")) {
      console.error("<toggle-all-accordions> needs an input as a child!");
    }

    this.addEventListener("change", (e) => {
      e.preventDefault();

      const items = Array.from(document.querySelectorAll("accordion-item"));
      labels.forEach((label) => {
        label.classList.toggle("hidden");
      });

      if (e.target.checked) {
        items.forEach((item) => {
          item.open();
        });
      } else {
        items.forEach((item) => {
          item.close();
        });
      }
    });
  }
}

customElements.define("toggle-all-accordions", ToggleAllAccordions);

/*
  Accordion Item
*/

class AccordionItem extends HTMLElement {
  constructor() {
    super();
    this.content = null;
    this.svg = null;
  }

  connectedCallback() {
    this.content = this.querySelector("div > div:nth-child(2)");
    this.svg = this.querySelector("svg");
    this.close();

    this.addEventListener("click", () => {
      if (this.content.style.maxHeight === "0px") {
        this.open();
      } else {
        this.close();
      }
    });
  }

  open() {
    this.content.style.maxHeight = this.content.scrollHeight + "px";
    this.svg.style.transform = "rotate(45deg)";
  }

  close() {
    this.content.style.maxHeight = "0";
    this.svg.style.transform = "rotate(0deg)";
  }
}

customElements.define("accordion-item", AccordionItem);

class NewsletterForm extends HTMLElement {
  connectedCallback() {
    const listId = this.dataset.listId;
    const statusText = this.querySelector(".success");
    this.addEventListener("submit", (e) => {
      e.preventDefault();
      const $form = this.querySelector("form");
      const $email = this.querySelector('[type="email"]');
      const $submit = this.querySelector('[type="submit"]');
      const $error = this.querySelector(".error");
      const submitText = $submit.innerHTML;
      const email = $email.value;
      const body = { email, listId };

      $submit.innerHTML = this.dataset.loadingText;
      $error.classList.add("hidden");

      const config = {
        body: JSON.stringify(body),
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
      };

      if (listId) {
        try {
          fetch(
            "https://hunni-serverless.vercel.app/api/revitin/subscribe",
            config
          )
            .then((res) => res.json())
            .then((data) => {
              $form.reset();
              $email.blur();
              $submit.innerHTML = submitText;
              statusText.classList.toggle("hidden");
              window.cvg({
                method: "track",
                eventName: "Subscribed To Newsletter",
                properties: {
                  form: "Footer",
                  formId: "XLSVK5",
                },
                profileProperties: {
                  $email: email,
                },
                aliases: [`urn:email:${email}`],
              });
            });
        } catch (e) {
          $submit.innerHTML = submitText;
          $error.classList.remove("hidden");
        }
      }
    });
  }
}

customElements.define("newsletter-form", NewsletterForm);

/*
Select Input
*/

class SelectInput extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const select = this.querySelector("select");
    const input = select.closest(".text-input");
    if (select.value && input) {
      input.classList.add("active");
    }
    select.addEventListener("change", (e) => {
      this.setActiveValue(e.target.value);
      if (input) {
        input.classList.add("active");
      }
    });
  }

  setActiveValue(val) {
    const options = Array.from(this.querySelectorAll("option"));
    const activeOption = options.find((o) => o.value === val);
    const target = this.querySelector(".select-target");

    if (activeOption) {
      target.innerHTML = activeOption.innerHTML;
    }
  }
}

customElements.define("select-input", SelectInput);
